import { useEffect, useState } from "react";
import { api, getAdminToken } from "@/lib/api";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const euros = (c) => (c / 100).toFixed(2).replace(".", ",") + " €";
export const adminAuth = () => ({ headers: { Authorization: `Bearer ${getAdminToken()}` } });
export const FAMILY_ACCENTS = ["#A63B36", "#C9A24B", "#8A4F7D", "#385E3A"];
export const STATUS_LABELS = { draft: "Brouillon", ready: "Prêt", published: "Publié" };

export function useCedaActive() {
  const [active, setActive] = useState(null);
  useEffect(() => {
    api.get("/ceda/status").then((r) => setActive(!!r.data.active)).catch(() => setActive(false));
  }, []);
  return active;
}

const CHUNK = 4 * 1024 * 1024;

export async function chunkedUpload(capsuleId, kind, file, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now());
  let last = null;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("total", String(total));
    fd.append("filename", file.name);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    last = await api.post(`/admin/ceda/capsules/${capsuleId}/upload/${kind}`, fd, {
      headers: { ...adminAuth().headers, "Content-Type": "multipart/form-data" },
    });
    onProgress && onProgress(Math.round(((i + 1) / total) * 100));
  }
  return last.data;
}

export async function startCedaPayment(provider, payload) {
  sessionStorage.setItem("tao_unlock_book", "ceda");
  const body = { ...payload, origin_url: window.location.origin };
  if (provider === "paypal") {
    const { data } = await api.post("/paypal/create-order", body);
    window.location.href = data.approve_url;
  } else {
    const { data } = await api.post("/payments/checkout", body);
    window.location.href = data.checkout_url;
  }
}

export function remaining(expiresAt) {
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return null;
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return { d, h, m, ms };
}
